import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { FeedbackComponent } from './pages/home-page/tabs/feedback/feedback.component';
import { ModelAccuracyComponent } from './pages/home-page/tabs/model-accuracy/model-accuracy.component';
import { ModelDefinitionsComponent } from './pages/home-page/tabs/model-definitions/model-definitions.component';
import { ModelPredictionsComponent } from './pages/home-page/tabs/model-predictions/model-predictions.component';
import { TradingStrategyComponent } from './pages/home-page/tabs/trading-strategy/trading-strategy.component';
import { UnauthorizedPageComponent } from './pages/unauthorized-page/unauthorized-page.component';
import { PageNotFoundPageComponent } from './pages/page-not-found-page/page-not-found-page.component';
import { ServerErrorPageComponent } from './pages/server-error-page/server-error-page.component';
import { registeredUserGuard } from './shared/interceptors/registered-user.guard';
import { NotLoggedPageComponent } from './pages/not-logged-page/not-logged-page.component';
import { calGuard } from '@cvx-dev/cal-angular';


export const routes: Routes = [
	{ path: '', redirectTo: 'model-predictions', pathMatch: 'full' },
	{ path: '',
		component: HomePageComponent,
		canActivateChild: [calGuard, registeredUserGuard],
		children: [
			{ path: 'feedback', component: FeedbackComponent },
			{ path: 'model-accuracy', component: ModelAccuracyComponent },
			{ path: 'model-definitions', component: ModelDefinitionsComponent },
			{ path: 'model-predictions', component: ModelPredictionsComponent },
			{ path: 'trading-strategy', component: TradingStrategyComponent },
		],
	},
	{ path: 'not-logged', component: NotLoggedPageComponent },
	{ path: '403', component: UnauthorizedPageComponent },
	{ path: '404', component: PageNotFoundPageComponent },
	{ path: '500', component: ServerErrorPageComponent },
	{ path: '**', redirectTo: 'model-predictions' }
];
